import { toast } from 'sonner'

import { manualSchedule } from '@/api/services/todo'
import { useTodoStore } from '@/store/useTodoStore'

/** TODO の予定時刻を変更して一覧を読み直す (失敗時は例外) */
export const applySchedule = async (todoId: number, start: Date, end: Date) => {
  await manualSchedule(todoId, { scheduled_start: start.toISOString(), scheduled_end: end.toISOString() })
  await useTodoStore.getState().loadTodos({ include_done: true })
}

/** applySchedule の結果をトーストで通知する。成功したら true */
export const rescheduleTodo = async (todoId: number, start: Date, end: Date) => {
  try {
    await applySchedule(todoId, start, end)
    toast.success('予定を更新しました')
    return true
  } catch (err) {
    toast.error(err instanceof Error ? err.message : '更新失敗')
    return false
  }
}
